const sectionCardFeeSizeImgCss = `
[data-type='section-card-fee-size-img'] {
  position: relative;
}

[data-type='section-card-fee-size-img'] [data-attribute='wrapper-container'] {
  position: relative;
  padding: 40px 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

[data-type='section-card-fee-size-img'] [data-attribute='wrapper-container'][data-overlay-enable='true']::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--overlay-color, transparent);
  z-index: 1;
  pointer-events: none;
}

[data-type='section-card-fee-size-img'] .wrapper-content {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
}

[data-type='section-card-fee-size-img'] .wrapper-content[data-center-y='true'] {
  align-items: center;
}

[data-type='section-card-fee-size-img'] .wrapper-content .wrap-image,
[data-type='section-card-fee-size-img'] .wrapper-content .wrap-text-ct {
  width: calc((100% - 30px) / 2);
}

[data-type='section-card-fee-size-img'] .wrapper-content .wrap-image {
  position: relative;
  z-index: 2;
  overflow: hidden;
  border-radius: 15px;
}

[data-type='section-card-fee-size-img'] .wrapper-content .wrap-image img {
  display: block;
  width: 100%;
  height: 100%;
}

[data-type='section-card-fee-size-img'] .wrapper-content .wrap-text-ct {
  position: relative;
  z-index: 2;
}

[data-type='section-card-fee-size-img'] .wrapper-content .wrap-text-ct h1,
[data-type='section-card-fee-size-img'] .wrapper-content .wrap-text-ct h2,
[data-type='section-card-fee-size-img'] .wrapper-content .wrap-text-ct h3 {
  font-size: 24px;
}

@container (max-width: 768px) {
  [data-type='section-card-fee-size-img'] [data-attribute='wrapper-container'] {
    padding: 16px 0;
  }

  [data-type='section-card-fee-size-img'] .wrapper-content .wrap-image,
  [data-type='section-card-fee-size-img'] .wrapper-content .wrap-text-ct {
    width: 100%;
  }

  [data-type='section-card-fee-size-img'] .wrapper-content .wrap-image {
    border-radius: 10px;
    order: 1 !important;
  }

  [data-type='section-card-fee-size-img'] .wrapper-content .wrap-text-ct {
    order: 2 !important;
  }

  [data-type='section-card-fee-size-img'] .wrapper-content .wrap-text-ct h1,
  [data-type='section-card-fee-size-img'] .wrapper-content .wrap-text-ct h2,
  [data-type='section-card-fee-size-img'] .wrapper-content .wrap-text-ct h3 {
    font-size: 16px;
  }
}
`;
export default sectionCardFeeSizeImgCss;
